import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Home from './pages/Home'
import WishList from './pages/WishList'
import Login from './pages/Login'
import Loading from './pages/Loading'
import UnknownUser from './pages/UnknownUser'
import { useAuth } from './context/AuthContext'
import './App.css'

function App() {
  const { isAuthenticated, isUserDirectoryLoading, userExists } = useAuth()
  const isReady = isAuthenticated && !isUserDirectoryLoading

  return (
    <Router>
      <div className="App">
        {isReady && userExists && <Header />}
        <main>
          {!isAuthenticated ? (
            <Login />
          ) : isUserDirectoryLoading ? (
            <Loading />
          ) : !userExists ? (
            <UnknownUser />
          ) : (
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/wishlist/:userId" element={<WishList />} />
            </Routes>
          )}
        </main>
      </div>
    </Router>
  )
}

export default App